// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.0
//   protoc               v6.30.2
// source: common/date_time/date_time.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../google/protobuf/timestamp";

export const protobufPackage = "common.date_time";

export interface OffsetDateTime {
  isoDate: string | undefined;
  offset: string;
}

function createBaseOffsetDateTime(): OffsetDateTime {
  return { isoDate: undefined, offset: "" };
}

export const OffsetDateTime: MessageFns<OffsetDateTime> = {
  encode(message: OffsetDateTime, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isoDate !== undefined) {
      Timestamp.encode(toTimestamp(message.isoDate), writer.uint32(10).fork()).join();
    }
    if (message.offset !== "") {
      writer.uint32(18).string(message.offset);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OffsetDateTime {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOffsetDateTime();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.isoDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.offset = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OffsetDateTime {
    return {
      isoDate: isSet(object.isoDate)
        ? globalThis.String(object.isoDate)
        : isSet(object.iso_date)
        ? globalThis.String(object.iso_date)
        : undefined,
      offset: isSet(object.offset) ? globalThis.String(object.offset) : "",
    };
  },

  toJSON(message: OffsetDateTime): unknown {
    const obj: any = {};
    if (message.isoDate !== undefined) {
      obj.isoDate = message.isoDate;
    }
    if (message.offset !== "") {
      obj.offset = message.offset;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OffsetDateTime>, I>>(base?: I): OffsetDateTime {
    return OffsetDateTime.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OffsetDateTime>, I>>(object: I): OffsetDateTime {
    const message = createBaseOffsetDateTime();
    message.isoDate = object.isoDate ?? undefined;
    message.offset = object.offset ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
